/**
 * @file 管理平台下线迁移通栏的展示状态
 * @author sunyingying01
 */

import {useCallback, useState} from 'react';

import {UserStore} from '@/stores';
import {MigrationPhase, isNoticeBannerClosed, markNoticeBannerClosed} from '@/utils/migration';

export interface MigrationBannerState {
    /** 通栏是否展示（外层布局需要据此让出 56px 高度） */
    visible: boolean;
    phase: MigrationPhase;
    /** 剩余天数 */
    days: number;
    /** 关闭通栏，仅轻量通知期可用 */
    onClose: () => void;
}

export function useMigrationBanner(userStore: UserStore): MigrationBannerState {
    const {migrationPhase, userId, workspaceOfflineDays} = userStore;
    const [noticeClosed, setNoticeClosed] = useState(() => isNoticeBannerClosed(userId));

    const onClose = useCallback(
        () => {
            markNoticeBannerClosed(userId);
            setNoticeClosed(true);
        },
        [userId]
    );

    const visible = migrationPhase === MigrationPhase.RESTRICTED
        || (migrationPhase === MigrationPhase.NOTICE && !noticeClosed);

    return {
        visible,
        phase: migrationPhase,
        days: workspaceOfflineDays ?? 0,
        onClose
    };
}
